<template>
  <div id="AssetView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
            <div class="page-title"> Fuel Ticket Details </div>
              <!-- Button for Clear Cache -->
               <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
               <div class="web-action-btn btn-groups text-right">
                   <router-link title="Edit Fuel ticket" v-if="fuelTicketData.status == 'entered'" class="btn btn-primary" v-bind:to="{name: 'FuelTicketEdit',params:{id:$route.params.id}}"><i class="fp-edit-icon"> </i> Edit</router-link>
                   <button type="submit" id="previewInvoiceBtn" v-on:click="previewTicket()" class="btn btn-secondary"><i class="fp-invoice"></i> Preview Ticket
                        </button>
                   <button v-if="canGenerateBill && showProcessBtn==true" id="statusVehicleModelBtn" v-on:click.prevent="changeFuelTicketStatus" class="btn btn-primary">Process</button>
                  <router-link
                    class="btn btn-secondary pull-right ml-1"
                    v-bind:to="{name: 'FuelTicketList'}"
                  > <i class="fp-back"></i> Back</router-link>
              </div>
          </div>
        <div class="container-fluid">
          <div class="admin-page-content customer-credit-detail list-view">
           <!-- <section class="internal-container"> -->
            <div id="tabs" class="containerTab mt-4">
              <div class="tabs">
                <a v-on:click="activetab = 1" v-bind:class="[activetab === 1 ? 'active' : '']">Fuel Ticket Details</a>
                <a v-on:click="activityLogs()" v-bind:class="[activetab === 2 ? 'active' : '']">Activity Log</a>
              </div>
            <div class="content">
            <div v-show="activetab === 1" class="tabcontent">
            <div class="list-sections">
              <!-- <div id="tabs" class="containerTab mt-3"> -->
                <!-- <div class="tabs"> -->
                  <!-- <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Fuel Ticket Details</a> -->
                  <!-- <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity Log</a> -->
                <!-- </div> -->
                <!-- <div class="content"> -->
                  <!-- <div class="tabcontent">
                    <div class="list-sections"> -->
                     <section class="internal-container">
                      <div class="form-row section-divider">
                          <div class="col-md-6">
                              <div class="row form-group">
                                 <label class="col">#Sequence:</label>
                                <span class="col">{{fuelTicketData.seq_number}}</span>
                              </div>

                              <div class="row form-group">
                                  <label class="col">Ticket Date:</label>
                                <span class="col">{{titleCase(fuelTicketData.ticket_date)}}</span>
                              </div>

                              <div class="row form-group">
                                <label class="col">Product:</label>
                                <span class="col">
                                     {{titleCase(fuelTicketData.company_name)}}
                                     <template v-if="fuelTicketData.item_name">
                                      | {{titleCase(fuelTicketData.item_name)}}
                                     </template>
                                    </span>
                              </div>
                              <div class="row form-group">
                                 <label class="col">Pump No:</label>
                                <span class="col">{{titleCase(fuelTicketData.tank_no)}}</span>

                              </div>

                              <div class="row form-group">
                                     <label class="col">Location:</label>
                                <span class="col">{{titleCase(fuelTicketData.company_name)}}</span>

                              </div>

                              <div class="row form-group">
                                  <label class="col">Status:</label>
                                <span class="col">{{titleCase(fuelTicketData.status)}}</span>
                              </div>
                              <div class="row form-group">
                               <label class="col">Customer:</label>
                                <span class="col">
                                      {{titleCase(fuelTicketData.custCode)}}
                                        <template v-if="fuelTicketData.custName">
                                        | {{titleCase(fuelTicketData.custName)}}
                                        </template>
                                </span>
                              </div>

                              <div v-if="misc_unit != ''" class="row form-group">
                                <label class="col">Misc Unit:</label>
                                <span class="col">
                                        {{misc_unit}}
                                </span>
                              </div>
                              <div v-else class="row form-group">
                                <label class="col">Unit:</label>
                                <span class="col">
                                        {{titleCase(fuelTicketData.vUnitNo)}}
                                        <template v-if="fuelTicketData.vtCode">
                                        | {{titleCase(fuelTicketData.vtCode)}}
                                        </template>
                                        <template v-if="fuelTicketData.vName">
                                        | {{titleCase(fuelTicketData.vName)}}
                                        </template>
                                </span>
                              </div>

                              <div class="row form-group">
                                   <label class="col">Bill Type:</label>
                                <span class="col">{{titleCase(fuelTicketData.billable_code_name)}} </span>

                              </div>
                              <div class="row form-group">
                                       <label class="col">UOM:</label>
                                <span class="col">{{fuelTicketData.measurement_unit}} </span>

                              </div>
                              <div class="row form-group">
                                  <label class="col">PO#:</label>
                                <span class="col">{{fuelTicketData.po_number}} </span>
                              </div>

                          </div>
                          <div class="col-md-6">
                              <div v-if="fuelTicketData.invoice_number != null" class="row form-group">
                                <label class="col">Invoice#:</label>
                                <span class="col">
                                <router-link  title="Fuel Ticket Invoice" class="color-blue" target="_blank" v-bind:to="{name: 'FuelTicketInvoice',params:{id:fuelTicketData.invoice_id},
                                query:{from:'fuel-ticket',fromUrl:fromUrl}}">{{fuelTicketData.invoice_number}}
                                </router-link>
                                 </span>

                              </div>

                              <div class="row form-group">
                                <template v-if="sectionArr && sectionArr.length">
                                  <template v-for="(sec,scval) in sectionArr">
                                    <label class="col" :key="scval+'_name'">{{sec.sectionName}}</label>
                                    <span class="col" :key="scval+'_reading'">{{sec.reading}} </span>
                                  </template>
                                </template>

                              </div>

                              <div class="row form-group">
                                <label class="col">Driver Id:</label>
                                <span class="col">{{fuelTicketData.driver_id}} </span>

                              </div>

                              <div class="row form-group">
                                <label class="col">Card Number:</label>
                                <span class="col">{{fuelTicketData.card_number}} </span>

                              </div>

                              <div class="row form-group">
                                 <label class="col">Quantity:</label>
                                <span class="col">{{fuelTicketData.quantity}} </span>
                              </div>
                              <!-- <div class="row form-group">
                                 <label class="col">Cost:</label>
                                <span class="col">{{titleCase(fuelTicketData.cost)}} </span>
                              </div> -->
                              <template v-if="userRole != 'fueler'">
                                  <div class="row form-group">
                                    <label class="col">Price:</label>
                                    <span class="col">${{fuelTicketData.price}} </span>
                                  </div>
                                  <div class="row form-group">
                                      <label class="col">Total:</label>
                                    <span class="col">${{amountFormat(fuelTicketData.total)}} </span>
                                  </div>

                                  <div class="row form-group">
                                        <label class="col">Tax:</label>
                                    <span class="col">{{fuelTicketData.ticket_cost[0].tax}} </span>
                                  </div>

                                  <div class="row form-group">
                                        <label class="col">Ticket Total:</label>
                                    <span class="col">${{amountFormat(fuelTicketData.ticket_total)}} </span>

                                  </div>
                              </template>

                              <div class="row form-group">

                                 <label class="col">Signature :</label>
                                  <span class="col">
                                    <template v-if="fuelTicketData.signature">
                                        <img :src="fuelTicketData.signature" alt="NA" height="90"/>
                                    </template>
                                    <template v-else>
                                        NA
                                    </template>
                                  </span>
                              </div>

                          </div>
                      </div>
                      <section class="internal-container " v-if="fuelTicketData.ticket_cost.length > 0 && userRole != 'fueler'">
                        <div class="table-reponsive">
                          <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1 purchase-order-item-table" >
                              <thead>
                                  <tr class="table-primary">
                                      <th>&nbsp;</th>
                                      <th class="text-right">Per UOM</th>
                                      <th class="text-right">Total</th>
                                      <th class="text-right">Tax</th>
                                      <th class="text-right">Ticket Total</th>
                                  </tr>
                              </thead>
                              <tbody v-if="fuelTicketData.ticket_cost != undefined && fuelTicketData.ticket_cost.length > 0">
                                  <template v-for="(ticketItem , ticketKey) in fuelTicketData.ticket_cost">
                                          <tr :key="'ticket'+ticketKey">
                                              <td>{{ticketItem.type}}</td>
                                              <td class="text-right">{{ticketItem.price}}</td>
                                              <td class="text-right">{{ticketItem.total}}</td>
                                              <td class="text-right">{{ticketItem.tax}}</td>
                                              <td class="text-right">{{ticketItem.ticket_total}}</td>
                                          </tr>
                                  </template>
                              </tbody>
                              <tbody v-else>
                                  <tr>
                                      <td colspan="5"><h5>No Data Found</h5></td>
                                  </tr>
                              </tbody>
                          </table>
                          </div>
                        </section>
                      </section>
                    <!-- </div>
                  </div> -->
                <!-- </div> -->

              <!-- </div> -->
            </div>
            </div>
            <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs">
              <fuel-activity-log-list :activityLogVal="activityLogsTabValue"></fuel-activity-log-list>
            </div>
            </div>

            <!-- General Ledger -->
            <section class="internal-container border-top-table-fl mt-4" v-if="activetab === 1 && canViewGL && glArr.length > 0">
                <template v-for="(glType , glTypeKey) in glArr">
                    <template v-if="glType.type != undefined && glType.type != null">
                        <template v-if="glType.detail != undefined && glType.detail.length > 0">
                            <div class="journal-title" :key="glType.type + glTypeKey">
                                <h5> {{glType.type}} <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#detail'+glTypeKey"></i>   </h5>
                            </div>
                            <div :id="'detail'+glTypeKey" class="accordian-body collapse show" :key="'detail'+glTypeKey">
                                <div class="table-reponsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-bordered">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Account</th>
                                                <th class="text-right">Debit</th>
                                                <th class="text-right">Credit</th>
                                                <th class="text-right">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="glType.detail != undefined && glType.detail.length > 0">
                                            <template v-for="(glItem , glKey) in glType.detail">
                                                    <tr :key="'gl'+glKey">
                                                        <template v-if="glItem.account_description == 'Total'">
                                                            <td class="text-right">{{glItem.account_description}}</td>
                                                        </template>
                                                        <template v-else>
                                                            <td>{{glItem.account_description}}</td>
                                                        </template>
                                                        <td class="text-right">{{glItem.debit}}</td>
                                                        <td class="text-right">{{glItem.credit}}</td>
                                                        <td class="text-right">{{glItem.journal_amount}}</td>
                                                    </tr>
                                            </template>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="4"><h5>No Data Found</h5></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </template>
                    </template>
                </template>
            </section>



            </div>
           <!-- </section> -->
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="col-md-12">
          <div class="error-template">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

    import Vue from "vue";

    
    import {commonMixins} from '../mixins/commonMixins';
    import ActivityLogListView from '@/components/ActivityLogList.vue';
    Vue.component("fuel-activity-log-list", ActivityLogListView);
    

    export default {
        name: "recordReceiptView",
        mixins:[commonMixins],

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            loading:false,
            canGenerateBill:false,
            fuelTicketData:[],
            ticketId:'',
            activetab: 1,
            activityLogsTabValue: "dontLoadList",
            activityLoaded:false,
            backPageUrl:"/fuel-ticket/list",
            showProcessBtn:false,
            userRole:'',
            canViewGL:false,
            glArr:[],
            fromUrl: "",
            sectionArr:[],
            misc_unit:'',
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_fuel_ticket') {
                            self.cantAccessPage = true;
                            self.canUpdateMod = true;
                        }
                        if (permissions[i].name == 'generate_fuel_bill') {
                            self.canGenerateBill = true;
                        }
                        if (permissions[i].name == 'view_general_ledger') {
                            self.canViewGL = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },

        mounted: function() {
            var self = this;

            self.fromUrl = btoa(window.location.pathname);

            var userObj = JSON.parse(localStorage.getItem("user_obj"));
            if (userObj != null) {
              if (userObj.roles.length > 0) {
                for(var i = 0; i < userObj.roles.length; i++){
                    if (userObj.roles[i].name == 'fueler') {
                        self.userRole = userObj.roles[i].name.toLowerCase();
                    }

                }
                // self.userRole = userObj.roles[0].name;
                // self.userRole = "fueler";
              }
            }


            self.getPermissions();
            self.loadFuelTicket();

            var pathUrl = window.location.pathname;
            var segments = pathUrl.split("/");
            self.ticketId=segments[3];

        },
        metaInfo() {
            return{
                title: (this.ticketId != "")? this.ticketId + "  Fuel Ticket View | " +process.env.COPYRIGHT_NAME:"Fuel Ticket View | " +process.env.COPYRIGHT_NAME
            }
        },
        methods: {

            loadFuelTicket() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-ticket/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.fuelTicketData=data.content
                            var storeObject={visited_page: {
                                    path : "FuelTicket |" +data.content.id,
                                    data : window.location.pathname,
                                    }};
                            self.getRecentlyPagesMethod(storeObject);
                            if(data.content.status=='entered')
                            {
                                self.showProcessBtn=true;
                            }else{
                                self.showProcessBtn=false;
                            }
                            //gl entry
                            if (data.content.gl != undefined && data.content.gl != null) {
                              self.glArr = data.content.gl;
                            }else{
                              self.glArr = [];
                            }

                            if (data.content.reading != undefined && data.content.reading.length){
                              self.sectionArr = data.content.reading;
                            }

                            if(data.content.is_miscellaneous == 1){
                              self.misc_unit = data.content.referance_no;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'ticket-by-id')
                    }
                });
            },
            changeFuelTicketStatus(){
                var self = this;
                 var path = window.location.pathname;
                var segments = path.split("/");
                 var fields = {
                    page: 0,
                    perPage: 0,
                    filters: [],
                    // messageData: self.message,
                    sort: [],
                    // exportFiltered: self.exportFilteredFlag
                    action:"process",
                    all:false,
                    id:[segments[3]]
                };
                 self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-ticket/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                               self.$swal('','Fuel Ticket Processed Successfully','info');
                               self.loadFuelTicket();
                        }else if(data.status == "error"){
                              self.$swal('',data.message,'info');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'process-fuel-ticket')
                    }
                });
            },
            titleCase(str) {
                if ( str == null ||  str == '') {
                    return "-";
                } else {
                    var value = str.toString();
                    return value.charAt(0).toUpperCase() + value.slice(1);
                }
            },
            activityLogs(){

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                self.$root.$emit('activity_log_opted','fuel ticket',segments[3]);
                self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
                self.activetab = 2;
            },
            previewTicket() {
                var self = this;
                self.$router.push("/fuel-ticket/preview/" + self.ticketId);
            }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/FuelTicketView.vue